// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepost {
  display: grid;
  gap: 1;
  margin-top: 4%;
}

.swiper-pagination {
  position: relative !important;
  bottom: 0px !important;
}
.postalign {
  display: flex;
}
@media screen and (min-width: 768px) {
  .postImageHome {
    overflow: hidden;
    padding: 4%;
  }
}

.image {
  width: 300px;
  height: 300px;
  object-fit: contain;
  margin-right: 80px;
}

.dateLikeSection {
  display: flex;
  margin: 3%;
  font-weight: 600;
}
.likes {
  display: grid;
  margin-left: 3%;
}
.titledesc {
  width: 80%;
}
.homePostDesc {
  width: 80%;
  text-align: start;
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
}
.postTitle {
  text-align: start;
  font-family: "Montserrat", sans-serif;
}
.homePostTitle :hover {
  width: -moz-fit-content;
  width: fit-content;
  color: black;
}

.posts {
  width: 80%;
}

.homecategory {
  font-weight: 300;
  border-radius: 3px;
}
@media screen and (max-width: 768px) {
  .posts{
    padding-left: 10%
  
  }
  .postalign {
    display: grid;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-bottom: 20%;
    padding-left: 2%
  }
  .homePostTitle {
    margin-top: -30px;
    margin-bottom: -20px;
    margin-left: 10px;
    text-align: center;
  }
  .titledesc {
    text-align: center;
    margin-left: 20px;
    margin-top: 1%;
  }

  .postImageHome {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    width: 350px;
    height: 300px;
  }

  .image {
    width: 350px;
    height: 300px;
    text-align: center;
    justify-content: center;
    align-items: center;
    object-fit: contain;
  }
  .homePostDesc {
    text-align: center;
  }
}
@media screen and (max-width: 768px) {
  .postImageHome {
    text-align: center;
    margin-left: 16px;
  }
  .homepost{
    margin-bottom: 50px;
  }
}
.homecategory {
  width: -moz-fit-content;
  width: fit-content;
  background: #93b1a7;
}
.page-link {
  background-color: #93b1a7;
  color: whitesmoke;
}
.page-item .activep {
  background-color: whitesmoke;
  color: #93b1a7;
}
.page-item :hover {
  background-color: whitesmoke;
  color: #93b1a7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE;;EAEF;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB;EACF;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;IAElB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":[".homepost {\n  display: grid;\n  gap: 1;\n  margin-top: 4%;\n}\n\n.swiper-pagination {\n  position: relative !important;\n  bottom: 0px !important;\n}\n.postalign {\n  display: flex;\n}\n@media screen and (min-width: 768px) {\n  .postImageHome {\n    overflow: hidden;\n    padding: 4%;\n  }\n}\n\n.image {\n  width: 300px;\n  height: 300px;\n  object-fit: contain;\n  margin-right: 80px;\n}\n\n.dateLikeSection {\n  display: flex;\n  margin: 3%;\n  font-weight: 600;\n}\n.likes {\n  display: grid;\n  margin-left: 3%;\n}\n.titledesc {\n  width: 80%;\n}\n.homePostDesc {\n  width: 80%;\n  text-align: start;\n  font-size: 17px;\n  font-family: \"Montserrat\", sans-serif;\n}\n.postTitle {\n  text-align: start;\n  font-family: \"Montserrat\", sans-serif;\n}\n.homePostTitle :hover {\n  width: fit-content;\n  color: black;\n}\n\n.posts {\n  width: 80%;\n}\n\n.homecategory {\n  font-weight: 300;\n  border-radius: 3px;\n}\n@media screen and (max-width: 768px) {\n  .posts{\n    padding-left: 10%\n  \n  }\n  .postalign {\n    display: grid;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    margin-bottom: 20%;\n    padding-left: 2%\n  }\n  .homePostTitle {\n    margin-top: -30px;\n    margin-bottom: -20px;\n    margin-left: 10px;\n    text-align: center;\n  }\n  .titledesc {\n    text-align: center;\n    margin-left: 20px;\n    margin-top: 1%;\n  }\n\n  .postImageHome {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    width: 350px;\n    height: 300px;\n  }\n\n  .image {\n    width: 350px;\n    height: 300px;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    object-fit: contain;\n  }\n  .homePostDesc {\n    text-align: center;\n  }\n}\n@media screen and (max-width: 768px) {\n  .postImageHome {\n    text-align: center;\n    margin-left: 16px;\n  }\n  .homepost{\n    margin-bottom: 50px;\n  }\n}\n.homecategory {\n  width: fit-content;\n  background: #93b1a7;\n}\n.page-link {\n  background-color: #93b1a7;\n  color: whitesmoke;\n}\n.page-item .activep {\n  background-color: whitesmoke;\n  color: #93b1a7;\n}\n.page-item :hover {\n  background-color: whitesmoke;\n  color: #93b1a7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
